module.exports = __webpack_public_path__ + "img/house_27.0d9ee111.jpg";